<y42-list-view
  y42FeatureListView
  [id]="$any('orchestration-dynamic-export-selector')"
  [canAdd]="false"
  [canEdit]="false"
  [hideQuickFilters]="true"
  [hasPadding]="false"
  [name]="''"
  [searchLabel]="'Search for exports'"
  [searchPlaceholder]="'Search for name, tables, ...'"
  [searchFieldAppearance]="'standard'"
  [searchFieldClasses]="'grid-row-search px-3'"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [frameworkComponents]="frameworkComponents"
  (gridSelectionChanged)="selectExports($event)"
  (gridReady)="gridReady($event)"
></y42-list-view>
